import { prefix } from './src/utils/constant'
import {
  mapObject
} from './src/utils'
import './common'

import table from './src/components/data/table'
import tableV2 from './src/components/data/table-v2/table'
import tableColumn from './src/components/data/table-v2/table-column'
import renderTableColumns from './src/components/data/table-v2/render-table-columns'
import tableOptimize from './src/components/data/table/table-optimize'
import treeTable from './src/components/data/tree-table'
import tableEditItem from './src/components/data/table/table-edit-item'
import cacheColumnsWidth from './src/components/data/cache-columns-width/cache-columns-width'
import ElTableEditabled from './src/components/data/table-editabled/el-table-editabled'
import ElTableEditabledCell from './src/components/data/table-editabled/el-table-editabled-cell'

import './src/components/data/bigdata-table'
import elTableFooter from './src/components/data/table-footer/el-table-footer'

let components = {
  table,
  tableOptimize,
  treeTable,
  cacheColumnsWidth,
  elTableFooter,
  ElTableEditabled,
  ElTableEditabledCell,
  tableV2,
  tableColumn,
  renderTableColumns
}

const install = Vue => {
  mapObject(components, component => {
    if (component.name) {
      Vue.component(prefix + component.name, component)
    } else {
      console.error('组件注册失败：缺少name')
    }
  })
}

export default {
  install,
  tableEditItem
}
